<template lang="pug">
v-content
    IPViewEmail(v-if="ip.ipForm == 'BIB-HSE-PPO-FRM-036-003'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    IPViewEmailKelistrikan(v-else-if="ip.ipForm == 'BIB-HSE-PPO-FRM-IZIN-KELISTRIKAN'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    PanasViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-FRM-036-001'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    PenggalianViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-FRM-036-004'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    RAViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-FRM-036-006'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    RTViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-FRM-036-002'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    RadioaktifViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-FRM-036-005'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    PeledakanViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-FRM-036-007'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    PengawalanViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-F-012-01'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    LampiranPengawalanViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-F-012-02'" :dialogType="dialogType" :activeStatus="activeStatus" :ip="ip" :approvalUser="dataUser")
    IzinTamuViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-IZIN-TAMU'" :dialogType="dialogType" :ip="ip" :activeStatus="activeStatus" :approvalUser="dataUser" title="Preview")
    JangkaPendekViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-FRM-018-03' && actionFor !== 'extendWaskat'" :dialogType="dialogType" :ip="ip" :activeStatus="activeStatus" :approvalUser="dataUser" title="Preview")
    JangkaPendekExtendViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-FRM-018-03' && actionFor === 'extendWaskat'" :dialogType="dialogType" :ip="ip" :activeStatus="activeStatus" :approvalUser="dataUser" title="Preview")
    IzinProyekViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-F-071-01'" :dialogType="dialogType" :ip="ip" :activeStatus="activeStatus" :approvalUser="dataUser" title="Preview")
    IzinUsahaJasaViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-PPO-F-071-02'" :dialogType="dialogType" :ip="ip" :activeStatus="activeStatus" :approvalUser="dataUser" title="Preview")
    UsulanPerubahanViewEmail(v-else-if="ip.ipForm == 'BIB-HSE-ES-F-2.07-01'" :dialogType="dialogType" :ip="ip" :activeStatus="activeStatus" :approvalUser="dataUser" title="Preview")
    UnauthorizedView(v-else-if="previewStatus == 0")

    v-row(justify="center")
      v-dialog(v-model="dialogInfo" persistent="" max-width="500")
        v-card(style="border-radius: 10px")
          v-card-title(class="text-h5 pt-8 px-8")
            div(v-if="errorCode === 4012" class="text-center")
              img(src="../assets/expired-token.png")
              h3(class="title-alert") Sesi Anda Telah Berakhir
              p(class="word-wrap info1") Silakan masuk kembali kedalam web iPermit, untuk proses penyetujuan izin kerja tersebut. Jika izin kerja tidak tersedia, kemungkinan sudah disetujui oleh anggota grup lain yang memiliki level yang sama.
              p(class="word-wrap info2") Untuk informasi lebih lengkap silahkan hubungi Departmen STC PT BIB. 
                a(:href="textWhatsapp" target="_blank" style="color: #ED1B24; text-decoration: none;") Disini
            p(v-else) {{ errorInfo }}
          v-card-actions(class="justify-center")
            v-btn(class="red mb-8 button-action-alert" rounded @click="toLogin()") Login
              img(src="../assets/next.png" class="ms-2")
</template>

<style>
.word-wrap {
  word-wrap: break-word; /* Older specification */
  overflow-wrap: break-word; /* Modern specification */
  word-break: break-word; /* Fallback for certain older browsers */
}
.button-action-alert {
  text-transform: none;
  width: 116px;
  height: 38px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff !important;
  background-color: #ED1B24 !important;
}
h3.title-alert {
  font-size: 20px;
  font-weight: 700;
  line-height: 24.2px;
  color: #5B6F87;
  margin-bottom: 10px;
}
p.info1 {
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
  text-align: center;
  color: #70829A;
}
p.info2 {
  font-size: 14px;
  font-weight: 700;
  line-height: 16.94px;
  text-align: center;
  color: #70829A;
}
</style>

<script>
import IPViewEmail from "@/components/IPViewEmail.vue";
import IPViewEmailKelistrikan from "@/components/IPViewEmailKelistrikan.vue";
import PanasViewEmail from "@/components/PanasViewEmail.vue";
import PenggalianViewEmail from "@/components/PenggalianViewEmail.vue";
import RAViewEmail from "@/components/RAViewEmail.vue";
import RTViewEmail from "@/components/RTViewEmail.vue";
import RadioaktifViewEmail from "@/components/RadioaktifViewEmail.vue";
import PeledakanViewEmail from "@/components/PeledakanViewEmail.vue";
import PengawalanViewEmail from "@/components/PengawalanViewEmail.vue";
import LampiranPengawalanViewEmail from "@/components/LampiranPengawalanViewEmail.vue";
import UnauthorizedView from "@/components/UnauthorizedView.vue";
import IzinTamuViewEmail from "@/components/IzinTamuViewEmail.vue"
import JangkaPendekViewEmail from "@/components/JangkaPendekViewEmail.vue"
import JangkaPendekExtendViewEmail from "@/components/JangkaPendekExtendViewEmail.vue"
import IzinProyekViewEmail from "@/components/IzinProyekViewEmail.vue"
import IzinUsahaJasaViewEmail from "@/components/IzinUsahaJasaViewEmail.vue"
import UsulanPerubahanViewEmail from "@/components/UsulanPerubahanViewEmail.vue"
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "Approval",
  components: {
    IPViewEmail,
    IPViewEmailKelistrikan,
    PanasViewEmail,
    PenggalianViewEmail,
    RAViewEmail,
    RTViewEmail,
    RadioaktifViewEmail,
    PeledakanViewEmail,
    PengawalanViewEmail,
    LampiranPengawalanViewEmail,
    UnauthorizedView,
    IzinTamuViewEmail,
    JangkaPendekViewEmail,
    JangkaPendekExtendViewEmail,
    IzinProyekViewEmail,
    IzinUsahaJasaViewEmail,
    UsulanPerubahanViewEmail
  },
  data() {
    return {
      ip: {},
      dialogType: "approval",
      activeStatus: null,
      dataUser: {},
      previewStatus: 1,
      actionFor: null,

      dialogInfo: false,
      errorInfo: '',
      errorCode: null,
      whatsappNumber: `https://wa.me/${process.env.VUE_APP_CALL_CENTER}`,
      ipNo: '',
    };
  },
  methods: {
    toLogin(){
      this.$router.push('/login');
    }
  },
  async mounted() {
    console.log('Starting mounted() lifecycle hook');
    const isAuthenticated = this.$store.getters.isAuthenticated;
    console.log('isAuthenticated:', isAuthenticated);
    
    if (isAuthenticated) {
      console.log('User is authenticated');
      const param = this.$route.query.actionFor;
      console.log('Query param actionFor:', param);
      
      if (param === 'extendWaskat') {
        console.log('Redirecting to Perpanjangan E-Waskat');
        this.$router.replace({name: 'Perpanjangan E-Waskat'});
        return;
      }
    }
    
    try {
      console.log('Entering try block');
      const p = this.$route.params;
      console.log('Route params:', p);
      
      const formCode = this.$route.query.formCode;
      console.log('formCode:', formCode);
      
      this.actionFor = this.$route.query.actionFor ?? null;
      console.log('actionFor:', this.actionFor);
      
      let url = `${this.API_URL}/preview-session/${p.ipId}/${p.token}?formCode=${formCode}`;
      url += (this.actionFor === 'extendWaskat') ? '&actionFor=extendWaskat' : '';
      console.log('API URL constructed:', url);
      
      const shortenEndPoint = `${this.API_URL}/v1/requests/shorten-sharable-url`;
      console.log('Shorten endpoint:', shortenEndPoint);
      
      console.log('Starting API request to preview-session');
      const getPreviewSession = await axios
        .get(url)
        .catch(error => {
          console.log('Error in preview session request:', error);
          const message = error.response?.data?.message ?? error.message;
          console.log('Error message:', message);
          
          this.errorCode = error.response?.data?.errorCode ?? 404;
          console.log('Error code:', this.errorCode);
          
          if ("data" in error.response?.data) {
            this.ipNo = error.response?.data?.data.ipNo;
            console.log('ipNo from error response:', this.ipNo);
          }
          throw new Error(message);
        });
      console.log('API request completed successfully');

      const data = getPreviewSession.data;
      console.log('Preview session data:', data);
      console.log('User IDs comparison:', {
        'dataUser?._id': data.dataUser?._id,
        'ip.ipUser._id': data.ip.ipUser._id,
        'store.dataUsers?._id': this.$store.state.dataUsers?._id
      });
      
      if(isAuthenticated && this.$store.state.dataUsers?._id === data.ip.ipUser._id) {
        console.log('Authenticated user is the IP user, redirecting to My Permit');
        this.$router.replace({name: 'My Permit'});
        return;
      } else if(isAuthenticated) {
        console.log('Authenticated user is not the IP user, redirecting to My Approval List');
        this.$router.replace({name: 'My Approval List'});
        return;
      }

      if (data.result.action < 0) {
        console.log('data.result.action < 0:', data.result.action);
        this.previewStatus = data.previewStatus;
        console.log('previewStatus:', this.previewStatus);
        
        if(this.previewStatus) {
          console.log('Processing preview status data');
          // combine with leave user data if exist
          let userData = getPreviewSession.data.dataUser;
          console.log('Initial userData:', userData);
          
          // Initialize arrays if they don't exist
          if (userData) {
            userData.group_level = userData.group_level || [];
            userData.department = userData.department || [];
            userData.companies = userData.companies || [];
            userData.location = userData.location || [];
          }
          
          if (userData?.leaveUser?.length > 0) {
            console.log('leaveUser data exists, length:', userData.leaveUser.length);
            
            for (const i of userData.leaveUser) {
              console.log('Processing leaveUser item:', i);
              
              // Skip if properties don't exist
              if (i.group_level && Array.isArray(i.group_level)) {
                i.group_level.forEach(el => {
                  if (el && !userData.group_level.includes(el)) {
                    console.log('Adding group_level:', el);
                    userData.group_level.push(el);
                  }
                });
              } else {
                console.log('No valid group_level array in this leaveUser item');
              }
              
              if (i.department && Array.isArray(i.department)) {
                i.department.forEach(el => {
                  if (el && !userData.department.includes(el)) {
                    console.log('Adding department:', el);
                    userData.department.push(el);
                  }
                });
              } else {
                console.log('No valid department array in this leaveUser item');
              }
              
              if (i.companies && Array.isArray(i.companies)) {
                i.companies.forEach(el => {
                  if (el && !userData.companies.includes(el)) {
                    console.log('Adding company:', el);
                    userData.companies.push(el);
                  }
                });
              } else {
                console.log('No valid companies array in this leaveUser item');
              }
              
              if (i.location && Array.isArray(i.location)) {
                i.location.forEach(el => {
                  if (el && !userData.location.includes(el)) {
                    console.log('Adding location:', el);
                    userData.location.push(el);
                  }
                });
              } else {
                console.log('No valid location array in this leaveUser item');
              }
            }
          }
          
          this.dataUser = userData;
          console.log('Final userData after processing:', this.dataUser);

          this.ip = getPreviewSession.data.ip;
          console.log('IP data:', this.ip);
          
          this.activeStatus = getPreviewSession.data.activeStatus;
          console.log('activeStatus:', this.activeStatus);
          
          console.log('Requesting shortened URL');
          const shortenedUrl = await axios.post(
            shortenEndPoint, 
            {"url": window.location.href, "justShorten": true}, 
            {headers: {"Authorization": `Bearer ${p.token}`}}
          );
          console.log('Shortened URL response:', shortenedUrl);
          
          this.ip.shortenUrl = shortenedUrl.data;
          console.log('Updated IP with shortened URL:', this.ip.shortenUrl);
        }
      } else {
        console.log('data.result.action >= 0:', data.result.action);
      }
    } catch (error) {
      console.log('Caught error in mounted():', error);
      
      if (isAuthenticated) {
        console.log('User is authenticated, redirecting to home');
        this.$router.replace('/');
        return;
      }
      
      this.errorInfo = error.message;
      console.log('Set errorInfo:', this.errorInfo);
      
      this.dialogInfo = true;
      console.log('Showing dialog info');
      
      this.$store.state.loader = false;
      console.log('Turned off loader');
    }
    console.log('Completed mounted() lifecycle hook');
  },
  watch: {
  },
  computed: {
    ...mapState(["API_URL"]),
    fullscreen() {
      // Adjust this condition to suit your needs
      return this.$vuetify.breakpoint.smAndDown;
    },
    maxWidth() {
      // Adjust max-width based on viewport size
      if (this.$vuetify.breakpoint.xsOnly) return '90%';
      if (this.$vuetify.breakpoint.smAndDown) return '75%';
      if (this.$vuetify.breakpoint.mdOnly) return '60%';
      return '50%';
    },
    textWhatsapp() {
      return `${this.whatsappNumber}?text=Hallo, mohon bantuannya saya tidak bisa approve permit dengan ipNo "${this.ipNo}"`;
    }
  }
};
</script>
